import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import type { ReactNode } from "react";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated, emailVerified, profile } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-[100dvh] items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  /**
   * Senza partita IVA non si entra, e non importa da quale porta si e' passati.
   *
   * Chi si iscrive col modulo la scrive li'. Chi entra con Google o Apple non
   * compila niente: senza questo controllo si ritroverebbe dentro l'app con la
   * prova attiva, e nessuno gli avrebbe mai chiesto se e' un'azienda.
   *
   * Il confronto sul percorso evita il giro infinito: la pagina che chiede la
   * partita IVA non puo' pretenderla per essere aperta.
   */
  if (profile && !profile.partita_iva && location.pathname !== "/completa-profilo") {
    return <Navigate to="/completa-profilo" replace />;
  }

  return <>{children}</>;
}